import { Dialog, Transition } from '@headlessui/react'
import { XIcon } from '@heroicons/react/outline'
import { Fragment } from 'react'
import React from 'react'
import { useAppState } from '../../../presenter'

type SlideOutProps = {
  title?: string
  onClose: () => void
  children: React.ReactNode
  maxWidth?: 'max-w-xl' | 'max-w-2xl' | 'max-w-3xl'
}

export function SlideOut({
  maxWidth = 'max-w-xl',
  ...props
}: SlideOutProps) {
  const { currentModal } = useAppState()

  return (
    <Transition.Root show={true} as={Fragment} appear>
      <Dialog
        as='div'
        className='fixed inset-0 overflow-hidden'
        onClose={() => {
          if (currentModal === 'None') {
            props.onClose()
          }
        }}
      >
        <div className='absolute inset-0 overflow-hidden'>
          <Transition.Child
            as={Fragment}
            enter='ease-in-out duration-500'
            enterFrom='opacity-0'
            enterTo='opacity-100'
            leave='ease-in-out duration-500'
            leaveFrom='opacity-100'
            leaveTo='opacity-0'
          >
            <Dialog.Overlay className='absolute inset-0 bg-gray-500 bg-opacity-75 transition-opacity backdrop-blur-md' />
          </Transition.Child>

          <div className='pointer-events-none fixed inset-y-0 left-10 flex max-w-full pl-10'>
            <Transition.Child
              as={Fragment}
              enter='transform transition ease-in-out duration-500 sm:duration-700'
              enterFrom='-translate-x-full'
              enterTo='-translate-x-0'
              leave='transform transition ease-in-out duration-500 sm:duration-700'
              leaveFrom='-translate-x-0'
              leaveTo='-translate-x-full'
            >
              <div className={`pointer-events-auto w-screen ${maxWidth}`}>
                <div className='flex h-full flex-col overflow-y-auto bg-white pt-28 pb-28 shadow-xl scroll-pb-20'>
                  <div className='px-4 sm:px-6'>
                    <div className='flex items-start justify-between'>
                      <Dialog.Title className='text-lg font-extrabold text-primary-300 normal-case'>
                        {props.title}
                      </Dialog.Title>
                      <div className='sticky top-0'>
                        <button
                          onClick={props.onClose}
                          className='rounded-full bg-primary-300 w-8 h-8 ml-4 text-center text-white '
                        >
                          <XIcon className='flex w-6 inline-block ml-auto mr-auto' />
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className='relative mt-6 flex-1 px-4 sm:px-6'>
                    {props.children}
                  </div>
                </div>
              </div>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  )
}
